import type { ServerResponse } from 'http'
import filter from 'lodash/filter'
import join from 'lodash/join'
import split from 'lodash/split'
import toString from 'lodash/toString'
import uniq from 'lodash/uniq'

import getFirst from '@Globals/getFirst'

export const addSurrogateKey = (res: ServerResponse, key: string) => {
  const previousRaw = getFirst(res.getHeader('surrogate-key'))
  const previous = split(toString(previousRaw), ' ')
  const current = filter(uniq([...previous, key]))
  const currentRaw = join(current, ' ')

  res.setHeader('surrogate-key', currentRaw)
}

/** Same semantics as express' res.vary(): append the field unless it is already listed (case-insensitively). */
export const addVary = (res: ServerResponse, field: string) => {
  const previous = filter(split(toString(getFirst(res.getHeader('vary'))), /\s*,\s*/))
  if (previous.includes('*') || previous.some(item => item.toLowerCase() === field.toLowerCase())) {
    return
  }

  res.setHeader('vary', join([...previous, field], ', '))
}
